import React from 'react';
import axios from 'axios';
import { Card, Button,Form,Avatar,Spin,Image,Modal,Input,message,Select,Checkbox,Switch } from 'antd';
import CompanyProfileForm from '../components/CompanyProfileForm'
import { UserOutlined } from '@ant-design/icons';
import { PlusOutlined,LoadingOutlined } from '@ant-design/icons';
import ImgsViewer from 'react-images-viewer'
import PhoneInput from 'react-phone-number-input'
import * as serverconfig from '../../views/serverconn'
import {
    Col,
    Row,
  } from 'reactstrap';

const FormItem=Form.Item;
const { Meta } = Card;
const { Option } = Select;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

var token= ''

class ApplicationDetail extends React.Component{

    state={
        companyname:'',  
        companyemail:'',
        companylogo:null,   
        companyphone:'',
        boxnumber:'',
        datarequested:true,  
        profile:{},
        withdrawpercentagecharge:0,
        depositpercentagecharge:0
    }


    componentDidMount(){
        if(localStorage.getItem("token")){
          token= localStorage.getItem("token")
      }else{
          token= ''
      }

         axios.defaults.headers={
            "Content-Type":"application/json",
            Authorization:`Token ${token}`
          }

        axios.get(`${serverconfig.backendserverurl}/api/companyprofile/${1}`)
        .then(res => {  
            this.setState({
                profile: res.data
            })

            this.setState({companyname:res.data.company_name})
            this.setState({companyemail:res.data.company_email})
            this.setState({companyphone:res.data.RegisteredPhoneNumber1})
            this.setState({boxnumber:res.data.box_number})
            this.setState({depositpercentagecharge:res.data.depositpercentagecharge})
            this.setState({withdrawpercentagecharge:res.data.withdrawpercentagecharge})

            this.setState({datarequested:false})
        })

     

    }


    handleCompanyNameChange= (e) => this.setState({ companyname: e.target.value});
    handleCompanyEmailChange= (e) => this.setState({ companyemail: e.target.value});
    handleCompanyLogoChange= (e) => this.setState({ companylogo: e.target.files[0]});
  
    handleCompanyPhoneChange= (e) => this.setState({ companyphone: e});
    handleCompanyBoxNumberChange= (e) => this.setState({ boxnumber: e.target.value});
  
    handledepositpercentagechargeChange= (e) => this.setState({ depositpercentagecharge: e.target.value});
    handlewithdrawpercentagechargeChange= (e) => this.setState({ withdrawpercentagecharge: e.target.value});


    //submit button pressed
    handleFormSubmit=() =>{
        const profileid=1;

        this.setState({datarequested:true})
        let form_data = new FormData();
        form_data.append('company_name', this.state.companyname);
        form_data.append('company_email', this.state.companyemail);
        form_data.append('RegisteredPhoneNumber1', this.state.companyphone);
        form_data.append('box_number', this.state.boxnumber);
        form_data.append('depositpercentagecharge', this.state.depositpercentagecharge);
        form_data.append('withdrawpercentagecharge', this.state.withdrawpercentagecharge);

        this.state.companylogo==null?
    
        console.log("No profile file")
        :
        form_data.append('company_logo', this.state.companylogo,this.state.companylogo?this.state.companylogo.name:"");
        

          axios.put(serverconfig.backendserverurl+`/api/companyprofile/${profileid}/`, form_data, {
            headers: {
              'content-type': 'multipart/form-data'
            }
          })
        .then(res => this.setState({datarequested:false})
        , window.location.reload(false),message.info('Successfully updated application profile')
        )
        .catch(error => console.log(error))

    }


    render(){
        if(this.state.datarequested===true){
            return(
              <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin indicator={antIcon} />
              </div>
            )
          }else{
            return(
                <div>
                    <Row>
                    <Col xs="12" sm="6" lg="6">
                    <Card title={this.state.profile.company_name}>
                        <p>Email: {this.state.profile.company_email}</p>
                        <p>Phone: {this.state.profile.RegisteredPhoneNumber1}</p>
                        <p>Box No: {this.state.profile.box_number}</p>
                        <p>Deposit percentage Charge: {this.state.profile.depositpercentagecharge}</p>
                        <p>Withdraw Percentage Charge: {this.state.profile.withdrawpercentagecharge}</p>
                    </Card>
                    </Col>
    
                    <Col xs="12" sm="6" lg="6">
                      <Card 
                            style={{padding:10,alignContent:'center',alignItems:'center'}}
                            hoverable
                            cover={
                            
                                <Image
                                width={100}
                                //height={'50%'}
                                src={this.state.profile.company_logo}    
                                />                   
                             }
                        >
                    </Card>


                   
                    </Col>
                   
    
                    </Row>
                    <br/>
    
                    <Row>
                    <Col xs="12" sm="6" lg="6">
                    <Card 
                            style={{padding:10}}
                            hoverable>
    
                        <h4>Sacco Profile Update</h4>
                        <Form
                            >
                                <FormItem label="Application Name"
                   
                                >
                                <Input name="applicationname"  placeholder="Put a name here." value={this.state.companyname} onChange={this.handleCompanyNameChange} />
                                </FormItem>
                    
                    
                                <FormItem label="Logo">
                                <Input name="companylogo" type="file" accept="image/png, image/jpeg" placeholder="Company logo"  onChange={this.handleCompanyLogoChange}/>
                                </FormItem>  
                                
                                <FormItem label="Email"
                 
                                >
                                <Input name="companyemail" type="email"  placeholder="company@email.com" value={this.state.companyemail} onChange={this.handleCompanyEmailChange} />
                                </FormItem> 
                    
                                <FormItem label="Phone Number">
                                <PhoneInput
                                    countrySelectProps={{ unicodeFlags: true }}
                                    defaultCountry="UG"
                                    placeholder="Enter phone number"
                                    value={this.state.companyphone} onChange={this.handleCompanyPhoneChange}/>
                                </FormItem>
                    
                                <FormItem label="Box number">
                                <Input name="boxnumber"  placeholder="Box number here" value={this.state.boxnumber} onChange={this.handleCompanyBoxNumberChange} />
                                </FormItem>


                                <FormItem label="Withdraw percentage Charge">
                                <Input name="withdrawpercentagecharge"  placeholder="Percentage" value={this.state.withdrawpercentagecharge} onChange={this.handlewithdrawpercentagechargeChange} />
                                </FormItem>
                    
                                <FormItem label="Deposit Percentage charge">
                                <Input  placeholder="percentage" value={this.state.depositpercentagecharge} onChange={this.handledepositpercentagechargeChange} />
                                </FormItem>      

                            <FormItem>
                            <Button type="primary" htmlType="button" onClick={(event) => this.handleFormSubmit()}>Update</Button>
                            </FormItem>
                            </Form>
                    </Card>
                       
    
                    </Col>
                
                    </Row>
    
                    <br/>
    
                </div>
            )

          }
     
    }
}

export default ApplicationDetail; 